import { RETURN_TO_PARAM } from "@arcadeai/ui-kit/utils/auth-redirect";
import {
  createFileRoute,
  Outlet,
  redirect,
  stripSearchParams,
} from "@tanstack/react-router";
import { z } from "zod";
import {
  AppShellSkeleton,
  setShellHint,
} from "@/components/custom/app-shell-skeleton";
import { StrongAuthReminder } from "@/components/custom/strong-auth-reminder";
import { sessionQueryOptions } from "@/lib/auth-client";

const searchParamsSchema = z.object({
  help: z.boolean().catch(false).default(false),
});

const defaultValues = {
  help: false,
};

export const Route = createFileRoute("/_authenticated")({
  validateSearch: searchParamsSchema,
  search: {
    middlewares: [stripSearchParams(defaultValues)],
  },
  pendingComponent: AppShellSkeleton,
  beforeLoad: async (ctx) => {
    const session =
      await ctx.context.queryClient.ensureQueryData(sessionQueryOptions);
    if (!session) {
      setShellHint(false);
      throw redirect({
        to: "/login",
        search: {
          [RETURN_TO_PARAM]: ctx.location.href,
        },
      });
    }
  },
  component: () => (
    <>
      <StrongAuthReminder />
      <Outlet />
    </>
  ),
});
